export const convertBlobURLToBase64 = async (blobURL) => {
  try {
    const response = await fetch(blobURL);
    if (!response.ok) {
      throw new Error("Failed to fetch blob data");
    }
    const blob = await response.blob();
    return await convertBlobToBase64(blob);
  } catch (error) {
    console.error("Error converting blob URL to Base64:", error);
    throw error;
  }
};

export const convertBlobToBase64 = async (blob) => {
  try {
    const reader = new FileReader();
    const result = await new Promise((resolve, reject) => {
      reader.onloadend = () => resolve(reader.result.split(",")[1]);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
    return result;
  } catch (error) {
    console.error("Error converting blob to Base64:", error);
    throw error;
  }
};